// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:16
import { TaskSplit_abstract } from './../abstract/SagaBase/TaskSplit_abstract';
export class TaskSplit extends TaskSplit_abstract {}
